export default {
  translation: {
    nav: {
      home: 'Hem',
      trips: 'Resor',
      aboutUs: 'Om oss',
      alerts: 'Notiser',
      wishlist: 'Önskelista',
      language: 'Språk',
      profile: 'Profil',
      settings: 'Inställningar',
      signIn: 'Logga in',
      signUp: 'Registrera'
    },
    hero: {
      title: 'Utforska Uganda',
      subtitle: 'och bortom',
      description: 'Upptäck Afrikas pärla med expertguider. Oförglömliga upplevelser väntar i Ugandas hisnande landskap och levande kultur.',
      searchPlaceholder: 'Vart vill du åka?',
      categories: {
        all: 'Alla',
        wildlife: 'Vilda djur',
        safari: 'Safari',
        cultural: 'Kultur',
        adventure: 'Äventyr',
        birding: 'Fågelskådning'
      }
    },
    common: {
      from: 'från',
      reviews: 'recensioner',
      viewMore: 'Visa mer',
      book: 'Boka',
      seeAll: 'Visa alla',
      loading: 'Laddar...'
    }
  }
};